import { useTranslation } from 'react-i18next';

interface InactivityWarningDialogProps {
  open: boolean;
  countdown: number;
  onContinue: () => void;
}

export function InactivityWarningDialog({
  open,
  countdown,
  onContinue,
}: InactivityWarningDialogProps) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4 animate-in fade-in duration-150">
      <div className="w-[350px] bg-white rounded-lg overflow-hidden shadow-xl animate-in zoom-in-95 duration-150">
        {/* Header */}
        <div className="bg-[#003366] px-[15px] py-[15px]">
          <p className="text-white font-poppins font-semibold text-base">
            {t('session.timeoutTitle', 'Session Timeout')}
          </p>
        </div>

        {/* Body */}
        <div className="min-h-[90px] px-[15px] py-[15px] flex items-start">
          <p className="text-sm font-poppins text-task-header-text">
            {t(
              'session.timeoutMessage',
              'Session is going to expire in {{count}} seconds. Would you like to continue?',
              { count: countdown }
            )}
          </p>
        </div>

        {/* Button */}
        <div className="flex justify-end px-[15px] pb-[15px]">
          <button
            type="button"
            onClick={onContinue}
            className="h-10 w-[100px] rounded-[4px] text-sm font-poppins font-semibold bg-[#003366] text-white"
          >
            {t('session.continue', 'Continue')}
          </button>
        </div>
      </div>
    </div>
  );
}
